module.exports = __webpack_public_path__ + "static/media/fun13.14fa9013.png";